import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

const ClearButton = ({visible, onClick, hoverText}) => {
  return visible ? (
    <IconButton 
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
      sx={{
        padding: 0,
        height: 19,
        width: 22,
        borderRadius: '2px',
        margin: 'auto 0',
        display: 'flex',
        color: 'var(--fourth-color)',
        '&:hover': {
          backgroundColor: 'var(--clear-button-bg-color)',
          color: 'var(--clear-button-bg-color)',
        },
      }}
    >
      <Tooltip title={hoverText} placement={"top"}>
        <svg 
          style={{
            height: 14,
            width: 14,
            color: 'inherit',
            margin: 'auto',
            fill: 'currentColor',
            stroke: 'currentColor',
            display: 'block',
            strokeWidth: 0,
          }}
          viewBox={"0 0 20 20"}
          aria-hidden={true}
          focusable={false}
        >
          <path  d={"M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"}/>
        </svg>
      </Tooltip>
    </IconButton>
  ) : null;
};

ClearButton.defaultProps = {
  visible: true,
  onClick: () => {},
  hoverText: "",
};

ClearButton.propTypes = {
  //If true the component will be rendered
  visible: PropTypes.bool,
  //What the Button does onClick
  onClick: PropTypes.func,
  //Optional text to display when hovering over button
  hoverText: PropTypes.string,
};

export default ClearButton;